import { computed, watch, ref, onBeforeUnmount, defineAsyncComponent, reactive, toRefs, onMounted } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { accounts } from '@/config/loan';
import Banner from './components/Banner';
import Tab from './components/Tab';
import Loan from './components/Loan';
// import Order from './components/Order';
// import Assets from './components/Assets';
import Question from './components/Question';
import { errorToast } from './hooks/useToast';
import Loading from './components/Loading';
export default {
  components: {
    Banner,
    Tab,
    Loan,
    Order: defineAsyncComponent({
      loader: () => import('./components/Order'),
      loadingComponent: Loading
    }),
    Assets: defineAsyncComponent({
      loader: () => import('./components/Assets'),
      loadingComponent: Loading
    }),
    Question,
    LoanVideo: defineAsyncComponent(() => import('./components/dialog/Video')),
    Vip: defineAsyncComponent({
      loader: () => import('./components/Vip'),
      loadingComponent: Loading
    })
  },
  setup() {
    const {
      t
    } = useI18n({
      useScope: 'global'
    });
    const store = useStore();
    const visible = ref(-1);
    const activeTab = computed(() => store.state.loan.tab);
    const isSubmember = computed(() => store.state.user.info.is_submember);
    const isOpenVideo = computed(() => store.state.loan.isOpenVideo);
    const isEnabledAccount = computed(() => store.getters['loan/isEnabledAccount']);
    const accountLoanTokensMap = computed(() => store.getters['loan/accountLoanTokensMap'] || {});
    // 是否为统一账户并且为资金账户
    // const isUFA = computed(() => store.getters['user/isUTA'] && store.getters['user/isFA']);
    const isLogin = computed(() => store.getters['user/isLogin']);
    const route = useRoute();
    const urlParams = route.query;
    // 设置初始化账户
    store.commit('loan/SET_ACCOUNT', accounts[urlParams.account] ? urlParams.account : 'spot');
    const state = reactive({
      videoInfo: {}
    });

    // 其他账户借贷币种列表
    watch(() => isEnabledAccount.value, () => {
      if (isEnabledAccount.value) {
        store.dispatch('loan/GET_ACCOUNT_LOAN_TOKENS');
      }
    }, {
      immediate: true
    });

    // 设置是否显示账户信息&是否重置现货账户
    watch([() => accountLoanTokensMap.value, () => isEnabledAccount.value], ([value, isEnabled]) => {
      const {
        account,
        currency
      } = urlParams;
      const len = Object.keys(value).length;
      // 链接无账户时 || 有账户但无效 || 现货账户
      if (!account || account && !accounts[account] || account === 'spot') {
        store.commit('loan/SET_IS_LOAN_TOKEN', true);
        return;
      }
      // 链接有效账户 && 无币种
      if (len && isEnabled && !currency) {
        store.commit('loan/SET_IS_LOAN_TOKEN', true);
        return;
      }
      // 链接有效账户 && 有币种 && 无效币种
      if (len && isEnabled && currency && !value[currency]) {
        store.commit('loan/SET_ACCOUNT', 'spot');
        store.commit('loan/SET_IS_LOAN_TOKEN', true);
      }
      // 链接有效账户 && 有币种 && 有效币种
      if (len && isEnabled && currency && value[currency]) {
        store.commit('loan/SET_IS_LOAN_TOKEN', true);
      }
    }, {
      immediate: true
    });
    if (!window.sfe.prerender) {
      store.dispatch('loan/INIT');
      // store.dispatch('user/GET_DEADPOOL_CONFIG');
    }

    onBeforeUnmount(() => {
      // 取消行情订阅
      store.dispatch('loan/UNSUB_MARKET_LIST');
    });
    onMounted(() => {
      // 中台白主题组件，会与html上的class="theme-light" 有关，所以这里需要处理下
      const {
        classList
      } = document.documentElement;
      classList.add('theme-light');
      classList.remove('theme-dark');
    });
    return {
      ...toRefs(state),
      visible,
      activeTab,
      isOpenVideo
    };
  }
};